/**
 * @generated SignedSource<<6d15c91e00b39dc0e6729fca28b73a76>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UrlMappingDestinationModeType = "STATIC" | "TEMPLATE" | "%future added value";
export type UrlMappingMatchType = "EXACT" | "PREFIX" | "REGEX" | "HOST_PATH" | "TRANSFORM" | "%future added value";
export type ImportUrlMappingsInput = {
  clientMutationId?: string | null;
  siteSlug: string;
  rows: ReadonlyArray<UrlMappingImportRowInput>;
};
export type UrlMappingImportRowInput = {
  name?: string | null;
  active?: boolean | null;
  matchType: UrlMappingMatchType;
  priority?: number | null;
  sourceUrl?: string | null;
  sourceUrls?: ReadonlyArray<string> | null;
  sourceHost?: string | null;
  sourcePath?: string | null;
  regexPattern?: string | null;
  destinationUrl: string;
  destinationMode?: UrlMappingDestinationModeType | null;
  conditions?: any | null;
  conditionsJson?: string | null;
  conditionQueryParamKey?: string | null;
  conditionQueryParamExact?: string | null;
  conditionQueryParamValues?: string | null;
  conditionPathContains?: string | null;
  conditionPathPrefix?: string | null;
  conditionPathExcludes?: string | null;
  conditionQueryContains?: string | null;
  conditionQueryExcludes?: string | null;
  conditionReferrerContains?: string | null;
  conditionTitleEquals?: string | null;
  conditionEnvironments?: string | null;
  startsAt?: string | null;
  endsAt?: string | null;
};
export type UrlMappingCsvUploadModal_Mutation$variables = {
  input: ImportUrlMappingsInput;
};
export type UrlMappingCsvUploadModal_MutationVariables = UrlMappingCsvUploadModal_Mutation$variables;
export type UrlMappingCsvUploadModal_Mutation$data = {
  readonly importUrlMappings: {
    readonly results: ReadonlyArray<{
      readonly rowIndex: number;
      readonly success: boolean;
      readonly errors: ReadonlyArray<{
        readonly field: string;
        readonly message: string;
      }>;
      readonly urlMapping: {
        readonly id: string;
      } | null;
    }>;
  } | null;
};
export type UrlMappingCsvUploadModal_MutationResponse = UrlMappingCsvUploadModal_Mutation$data;
export type UrlMappingCsvUploadModal_Mutation = {
  variables: UrlMappingCsvUploadModal_MutationVariables;
  response: UrlMappingCsvUploadModal_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportUrlMappingsPayload",
    "kind": "LinkedField",
    "name": "importUrlMappings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UrlMappingImportResult",
        "kind": "LinkedField",
        "name": "results",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowIndex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImportError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UrlMapping",
            "kind": "LinkedField",
            "name": "urlMapping",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlMappingCsvUploadModal_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UrlMappingCsvUploadModal_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "98409e01c8ed36a39030f7dcbfd75140",
    "id": null,
    "metadata": {},
    "name": "UrlMappingCsvUploadModal_Mutation",
    "operationKind": "mutation",
    "text": "mutation UrlMappingCsvUploadModal_Mutation(\n  $input: ImportUrlMappingsInput!\n) {\n  importUrlMappings(input: $input) {\n    results {\n      rowIndex\n      success\n      errors {\n        field\n        message\n      }\n      urlMapping {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "76f18b28c1f9db2ec4ba94afd5ed7363";

export default node;
